<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12" class="mt-1 text-center">
        <h1>Add Training Courses</h1>
        <b-button variant="outline-success" class="float-right" @click="submitCourses">Save Course</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" offset="3" class="mt-1 text-left" style="height:470px; overflow-y:auto;">
        <b-form>
          <b-form-group label="Course Title">
            <b-input
              type="text"
              placeholder="Enter Course Title"
              v-model="$v.form.courseTitle.$model"
              :state="$v.form.courseTitle.$dirty ? !$v.form.courseTitle.$error : null"
              @blur.native="onSelectChange"
            ></b-input>
            <b-form-invalid-feedback
              class="error"
              v-if="!$v.form.courseTitle.required"
            >This is a required field and must be enter atleast 5 characters</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Description">
            <b-form-textarea
              placeholder="Enter your Description..."
              rows="3"
              max-rows="6"
              v-model="$v.form.description.$model"
              :state="$v.form.description.$dirty ? !$v.form.description.$error : null"
              @blur.native="onSelectChange"
            ></b-form-textarea>
            <b-form-invalid-feedback
              class="error"
              v-if="!$v.form.description.required"
            >This is a required field and must be enter atleast 10 characters</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Select Course Form">
            <b-form-select
              v-model="$v.form.onboardingForms.$model"
              :state="$v.form.onboardingForms.$dirty ? !$v.form.onboardingForms.$error : null"
              :options="optionsForms"
              @blur.native="onSelectChange"
            ></b-form-select>
            <b-form-invalid-feedback
              class="error"
              v-if="!$v.form.onboardingForms.required"
            >This is a required field and must be select One option</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Select Exams">
            <b-form-select
              v-model="form.selectExam"
              :options="optionsExams"
            ></b-form-select>
          </b-form-group>
          <b-form-group label="Practice Question" hidden>
            <b-form-select
              v-model="form.practiceQuestion"
              :options="optionsPracticeQuestion"
            ></b-form-select>
            <b-form-invalid-feedback
              class="error"
            >This is a required field and must be select One option</b-form-invalid-feedback>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-modal
      id="submit-question-modal"
      ok-only
      ok-title="Close"
      no-close-on-backdrop
      hide-footer
      size="sm"
      v-model="showModal"
      scrollable
    >
      <template v-slot:modal-header="{ close }">
        <h5>Create Courses</h5>
      </template>
      <div v-if="!submiting && !responseSuccess">
        <p>Are you sure you would like to create the Courses</p>
      </div>
      <div v-else-if="submiting && !responseSuccess">
        <p>Your courses is being submited......</p>
        <b-spinner type="grow" label="Loading..."></b-spinner>
      </div>

      <div v-else>
        <p class="my-2 text-center">
          Your courses has been created successfully.
          <br />
        </p>
      </div>
      <div class="float-right">
        <b-button
          size="sm"
          variant="danger"
          class="mr-3"
          v-if="!submiting"
          @click="resetFormModal"
        >Close</b-button>
        <!-- Button with custom close trigger value -->
        <b-button
          size="sm"
          v-if="!responseSuccess"
          :disabled="submiting"
          variant="outline-success"
          @click="postData"
        >Submit</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Helper } from "../helpers";
import { HTTP } from "../utils/HTTP";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "AddExams",
  mixins: [validationMixin],
  components: {},
  data() {
    return {
      companyId:this.$route.params.companyId,
      isLoading: false,
      submiting: false,
      responseSuccess: false,
      showModal: false,
      form: {
        courseTitle: null,
        description: null,
        selectExam: null,
        practiceQuestion: null,
        onboardingForms: null
      },
      optionsExams: [],
      optionsCompany: [],
      optionsPracticeQuestion: [],
      optionsForms: [],
    };
  },
  validations: {
    form: {
      courseTitle: {
        required,
        minLength: minLength(5)
      },
      description: {
        required,
        minLength: minLength(10)
      },
      
      onboardingForms: {
        required
      }
    }
  },
  computed: {},
  mounted() {
    this.$nextTick(function() {
      this.getExams().then(res => {
        this.optionsExams = res;
      });
      this.getForms().then(res => {
        this.optionsForms = res;
      });
      this.getPracticeQuestion().then(res => {
        this.optionsPracticeQuestion = res;
      });
    });
  },
  methods: {
    resetFormModal() {
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showModal = false;
    },
    onSelectChange() {
      this.$v.form.courseTitle.$touch();
      this.$v.form.description.$touch();
      this.$v.form.onboardingForms.$touch();
    },
    submitCourses() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.showModal = true;
    },
    getExams() {
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP("post", "v1/training/getallexams", {
        Authorization: token
      });
      return result
        .then(response => {
          const items = response.data.response;
          this.isLoading = false;
          return items.map(item => {
            const { exam_title, id } = item;
            return { text: exam_title, value: id };
          });
        })
        .catch(error => {
          this.isLoading = false;
          return [];
        });
    },
    
    getPracticeQuestion() {
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP("post", "v1/training/getallpracticequestions", {
        Authorization: token
      });
      return result
        .then(response => {
          const items = response.data.response;
          this.isLoading = false;
          return items.map(item => {
            const { question, is_practice_question } = item;
            return { text: question, value: is_practice_question };
          });
        })
        .catch(error => {
          this.isLoading = false;
          return [];
        });
    },
    async getForms() {
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");

      try {
        let result = await HTTP(
          "get",
          "v1/client-profile/forms/getforms/dropdown/" + this.companyId,
          null,
          {
            Authorization: token
          }
        );
        return result.data.map(item => {
            const { title, id } = item;
            return { text: title, value: id };
          });
        // this.optionsForms = result.data;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    async createCoursesApiCall() {
      this.formData = {
        courses_title: this.form.courseTitle,
        description: this.form.description,
        exam_id: this.form.selectExam,
        form_id: this.form.onboardingForms,
        company_id: this.companyId,
        practice_question_id: this.form.practiceQuestion
      };
      this.submiting = true;
      this.isLoading = true;
      const URI = "v1/training/addcourse",
        headers = {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        };
      const Result = HTTP("post", URI, this.formData, headers, null, true);
      return Result.then(response => {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        this.$v.$reset();
      }).catch(err => {
        this.isLoading = false;
        this.submiting = false;
      });
    },
    postData() {
      this.createCoursesApiCall();
      (this.form.courseTitle = null),
        (this.form.description = null),
        (this.form.selectExam = null),
        (this.form.onboardingForms = null),
        (this.form.practiceQuestion = null);
      this.$v.$reset();
    }
  }
};
</script>